import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";
import { FormGroup, FormBuilder } from '@angular/forms';

import * as globalConst from './../../../constants';

@Injectable()
export class RelationsService {

  constructor(private http: Http) { }

  private apiUrl = globalConst.baseAPI;  // URL para web api 



  getEconomicGroupClassifications(){
    return this.http
    .get(this.apiUrl + "/classificationgroup/v1/getclassificationgroup?$filter=Ativo&$orderby=Nome asc", JSON.parse(localStorage.getItem('yara.connectionHeader')))
    .map((res: Response) => res.json()).catch(e => {
      if (e.status === 401) {
        return Observable.throw('Unauthorized');
      }
    });
  }

  
  getRelations(page:number,name:string, classificacao:number, sort:string, orderby:string){
    page = page * globalConst.paginationSkip;
    var classificationFilter = "";
    if (classificacao >0) classificationFilter = "and ClassificacaoGrupoEconomicoID eq " + classificacao;
    console.log("classificacao",classificationFilter);
    return this.http
    .get(this.apiUrl + "/relationshiptypegroup/v1/getrelationshiptypegroupall?$orderby=" + orderby + " " + sort + "&$top="+globalConst.paginationSkip+"&$skip=" + page + "&$filter=startswith(tolower(Nome),'" + name.toLowerCase() + "') "+classificationFilter , JSON.parse(localStorage.getItem('yara.connectionHeader')))
    .map((res: Response) => res.json()).catch(e => {
      if (e.status === 401) {
        return Observable.throw('Unauthorized');
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/relations/service/relations.service.ts